import { createSlice } from "@reduxjs/toolkit";

export const all_farm_fields = createSlice({
  name: "all_farm_fields",
  initialState: {
    value: {
      status: false,
      data: [{ farmid: "", fieldData: [] }],
      farmid: "",
    },
  },
  reducers: {
    updateUserFields: (state, action) => {
      const newData = {
        farmid: action.payload?.farmid,
        fieldData: action.payload?.fieldData,
      };
      state.value.status = true;
      if (!state.value.data[0]?.farmid) {
        state.value.data = [newData];
      } else {
        state.value.data = [...state.value.data, newData];
      }
    },
    updateFarmField: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.data];
      state.value.data.forEach((item, index) => {
        //find and append new field data to matching farm ID
        if (action.payload?.farmid === item.farmid) {
          existingData.splice(index, 1, {
            farmid: item.farmid,
            // [...existing fields, new field data]
            fieldData: [...item?.fieldData, action.payload?.fieldData],
          });
        }
      });
      state.value.data = existingData;
    },
    removeField: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.data];

      state.value.data?.forEach((item, index) => {
        if (action.payload?.farmId === item.farmid) {
          item?.fieldData.forEach((val, ind) => {
            if (val?._id === action.payload?.fieldId) {
              existingData[index]?.fieldData.splice(ind, 1);
            }
          });
        }
      });
      state.value.data = existingData;
    },
  },
});

export const { updateUserFields, updateFarmField, removeField } =
  all_farm_fields.actions;

export default all_farm_fields.reducer;
